<template>
  <div class="tips">

    <el-tooltip effect="dark" :content="`${isShow?'收起':'查看更多'}`" placement="top-start">
      <el-link class="title" @click="showList=!showList">
        <span>
          <i class="el-icon-info" style="font-size: 1.2rem;color: #ff3176"></i>
          {{ title }}
        </span>
        <i v-if="!isShowAll" :class="isShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="arrow"></i>
      </el-link>
    </el-tooltip>
    <ol v-if="isShow">
      <li v-for="(msg,index) in data" :key="index" v-html="msg"></li>
    </ol>
  </div>
</template>

<script>
export default {
  name: "Tips",
  data() {
    return {
      showList: false
    }
  },
  props: {
    data: {
      type: [Array, Object],
      default() {
        return {}
      }
    },
    title: {
      type: String,
      default() {
        return '备注：'
      }
    },
    isShowAll: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  computed: {
    isShow() {
      let data = false
      if (!this.isShowAll)
        data = this.showList
      else data = this.isShowAll
      return data
    }
  },
}
</script>

<style scoped>
.title {
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
}

.arrow {
  margin-left: 4px;
  font-size: 12px;
  color: #909399;
}

.tips {
  margin-top: 10px;
}

.tips li {
  /*font-weight: lighter;*/
  font-size: 0.9em;
  /*font-style: italic;*/
  color: #909399;
  margin-bottom: 5px;
}

</style>
